import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getIsPublishing,
  getPublishError,
  getIsUnpublishing,
  getUnpublishError,
  getIsMarkingAsUptoDate,
  getMarkAsUptoDateError,
  getDicardDraftError,
  getIsDiscardingDraft,
  getIsImportingPpiUpdate,
  getImportUpdatePpiError,
  getIsImportingGlobalPpi,
  getImportGlobalPpiError
} from '../selectors';
import {
  publishPpi,
  unpublishPpi,
  markAsUptoDatePpi,
  importUpdatePPI,
  discardDraftPpi,
  importGlobalUpdatePpi
} from '../actions';

const Action = {
  PUBLISH: {
    reduxAction: publishPpi,
    getRunningSelector: getIsPublishing,
    getErrorSelector: getPublishError
  },
  UNPUBLISH: {
    reduxAction: unpublishPpi,
    getRunningSelector: getIsUnpublishing,
    getErrorSelector: getUnpublishError
  },
  MARKASUPTODATE: {
    reduxAction: markAsUptoDatePpi,
    getRunningSelector: getIsMarkingAsUptoDate,
    getErrorSelector: getMarkAsUptoDateError
  },
  DISCARD_DRAFT: {
    reduxAction: discardDraftPpi,
    getRunningSelector: getIsDiscardingDraft,
    getErrorSelector: getDicardDraftError
  },
  IMPORTIFOODUPDATEPPI: {
    reduxAction: importUpdatePPI,
    getRunningSelector: getIsImportingPpiUpdate,
    getErrorSelector: getImportUpdatePpiError
  },
  IMPORTGLOBALPPIUPDATE: {
    reduxAction: importGlobalUpdatePpi,
    getRunningSelector: getIsImportingGlobalPpi,
    getErrorSelector: getImportGlobalPpiError
  }
};

const usePpiAction = action => {
  const [isStarted, setIsStarted] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const dispatch = useDispatch();
  const isRunning = useSelector(action.getRunningSelector);
  const error = useSelector(action.getErrorSelector);
  const isDoneWithoutError = isStarted && !isRunning && !error;

  if (action.debug) {
    console.log('usePpiAction()', action);
    console.log('   -- isStarted', isStarted);
    console.log('   -- isCompleted', isCompleted);
    console.log('   -- isRunning', isRunning);
    console.log('   -- error', error);
    console.log('   -- isDoneWithoutError', isDoneWithoutError);
  }

  if (isDoneWithoutError) {
    if (!isCompleted) {
      if (action.debug) {
        console.log(' --> Mark as completed');
      }
      setIsCompleted(true);
    }
  }

  const performAction = (id, data) => {
    console.log('usePpiAction().perform()', id, action, data);
    dispatch(action.reduxAction(id, data));
    setIsStarted(true);
  };

  return [performAction, isRunning, isCompleted];
};

export const usePublishPpi = () => usePpiAction(Action.PUBLISH);
export const useUnpublishPpi = () => usePpiAction(Action.UNPUBLISH);
export const useMarkAsUptoDatePpi = () => usePpiAction(Action.MARKASUPTODATE);
export const useDiscardDraftPpi = () => usePpiAction(Action.DISCARD_DRAFT);
export const useImportUpdatePpi = () =>
  usePpiAction(Action.IMPORTIFOODUPDATEPPI);
export const useImportGlobalPpiUpdate = () =>
  usePpiAction(Action.IMPORTGLOBALPPIUPDATE);
